<template>
  <div>
    <div>
      <strong>{{ $t('module.proj.project.cashierFlowTrans.fundStatCardTitle') }}</strong>
    </div>
    <Divider />

    <Option value="IN_TITLE" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      <div :style="{'float':'left','width':'200px','text-align': 'right'}">
        {{ $t('common.commonVar.colIn') }}
      </div>
      <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
      </div>
    </Option>
    <template v-for="item in fundStatAcct.inEntityVOList">
      <Option :label="item.entityName" :key="item.entityId" :value="item.entityId" :style="{'float':'left','text-align': 'left'}">
        <div :style="{'float':'left','width':'200px', 'text-align':'right'}">
          <span>{{ item.entityName }}</span>
        </div>
        <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
<!--          {{ formatThousandthNumberAllowZero(amountMap[item.entityId] || 0) }}-->
          {{ formatThousandthNumberAllowZero(item.feeAmt || 0) }}
        </div>
      </Option>
    </template>
    <Option value="IN_SUM" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      <div :style="{'float':'left','width':'200px','text-align': 'right'}">
        {{ $t('common.commonVar.subTotal') }}
      </div>
      <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
        {{ formatThousandthNumberAllowZero(this.getSummaryList(fundStatAcct.inEntityVOList) || 0) }}
      </div>
    </Option>

    <Option value="IN_DIVIDER" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      &nbsp;
    </Option>

    <Option value="OUT_TITLE" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      <div :style="{'float':'left','width':'200px','text-align': 'right'}">
        {{ $t('common.commonVar.colOut') }}
      </div>
      <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
      </div>
    </Option>
    <template v-for="item in fundStatAcct.outEntityVOList">
      <Option :label="item.entityName" :key="item.entityId" :value="item.entityId" :style="{'float':'left','text-align': 'left'}">
        <div :style="{'float':'left','width':'200px', 'text-align':'right'}">
          <span>{{ item.entityName }}</span>
        </div>
        <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
<!--          {{ formatThousandthNumberAllowZero((-1 * amountMap[item.entityId]) || 0) }}-->
          {{ formatThousandthNumberAllowZero((item.feeAmt) || 0) }}
        </div>
      </Option>
    </template>
    <Option value="OUT_SUM" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      <div :style="{'float':'left','width':'200px','text-align': 'right'}">
        {{ $t('common.commonVar.subTotal') }}
      </div>
      <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
        {{ formatThousandthNumberAllowZero(this.getSummaryList(fundStatAcct.outEntityVOList) || 0) }}
      </div>
    </Option>

    <Option value="OUT_DIVIDER" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      &nbsp;
    </Option>

    <Option value="SUM" :style="{'float':'left','text-align': 'left', 'font-weight':'bold'}">
      <div :style="{'float':'left','width':'200px','text-align': 'right'}">
        {{ $t('common.commonVar.total') }}
      </div>
      <div :style="{'float':'left','width':'100px', 'text-align':'right'}">
<!--        {{ formatThousandthNumberAllowZero(this.getSummaryList([].concat(fundStatAcct.inEntityVOList).concat(fundStatAcct.outEntityVOList)) || 0) }}-->
        {{ formatThousandthNumberAllowZero((this.getSummaryList(fundStatAcct.inEntityVOList) || 0) - (this.getSummaryList(fundStatAcct.outEntityVOList) || 0)) }}
      </div>
    </Option>
  </div>
</template>

<script>
import * as Utils from '@/utils'

export default {
  props: {
    // searchedInfo: {
    //   searchType: '', // ALL, MONTH, DT_SCOPE
    //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    //   searchCtrAcctId: '',
    //   searchFundStatEntityIdList: [],
    //   paymentId: ''
    // },
    fundStatAcct: {
      type: Object,
      require: true,
      default: () => {
        return {
          inEntityVOList: [],
          outEntityVOList: []
        }
      }
    }
    // ,
    // transList: {
    //   type: Array,
    //   require: true,
    //   default: () => {
    //     return []
    //   }
    // }
  },
  data() {
    return {
      // fundStatAcct: {
      //   inEntityVOList: [],
      //   outEntityVOList: []
      // },
      // inAmtMap: {},
      // outAmtMap: {}
      // amountMap: {}
    }
  },
  computed: {
    // projSettlePaymentDDList() {
    //   return this.$store.state.rspFeeNameManage.projSettlePaymentDDList
    // }
  },
  methods: {
    getSummaryList(list) {
      if (!list) {
        return 0
      }
      let sum = 0
      for (let i = 0; i < list.length; i++) {
        sum += list[i].feeAmt
      }
      return sum
    },
    // getSummary(amtMap, type) {
    //   // debugger
    //   let sum = 0
    //   if (type) {
    //     // debugger
    //     let entityIdMap = {}
    //     let entityVOList = (type === 'IN') ? this.fundStatAcct.inEntityVOList : this.fundStatAcct.outEntityVOList
    //     entityVOList = entityVOList || []
    //     entityVOList.forEach(function (item) {
    //       entityIdMap[item.entityId] = item
    //     })
    //     // 收入/支出小计
    //     Object.keys(amtMap).forEach(function (key) {
    //       if (entityIdMap[key]) {
    //         sum += amtMap[key] * (type === 'IN' ? 1 : -1)
    //       }
    //     })
    //   } else {
    //     // 收入支出总计
    //     Object.keys(amtMap).forEach(function (key) {
    //       sum += amtMap[key]
    //     })
    //   }
    //   return sum
    // },
    formatThousandthNumberAllowZero: Utils.formatThousandthNumberAllowZero,
    END_METHODS() {}
  },
  async mounted() {
    // debugger
    // const paymentMap = {}
    // console.log(this.projId)
    // console.log('this.searchedInfo:', this.searchedInfo)
    console.log('this.fundStatAcct:', this.fundStatAcct)
    // let amountMap = {}
    // // let outAmtMap = {}
    // for (let i = 0; i < this.transList.length; i++) {
    //   let trans = this.transList[i]
    //   // let inAmt = inAmtMap[trans.fundStatEntityId] ? inAmtMap[trans.fundStatEntityId] : 0
    //   // inAmtMap[trans.fundStatEntityId] = inAmt + trans.inAmt
    //   // let outAmt = outAmtMap[trans.fundStatEntityId] ? outAmtMap[trans.fundStatEntityId] : 0
    //   // outAmtMap[trans.fundStatEntityId] = outAmt + trans.outAmt
    //   let amount = amountMap[trans.fundStatEntityId] ? amountMap[trans.fundStatEntityId] : 0
    //   amountMap[trans.fundStatEntityId] = amount + (trans.inAmt - trans.outAmt)
    // }
    // let fundStatAcct = this.fundStatAcct
    // let transList = this.transList
    // debugger
    // this.inAmtMap = inAmtMap
    // this.outAmtMap = outAmtMap
    // this.amountMap = amountMap
    // console.log('this.inAmtMap:', {...this.inAmtMap})
    // console.log('this.outAmtMap:', {...this.outAmtMap})
    // console.log('this.inAmtMap + this.outAmtMap:', {...this.outAmtMap, ...this.inAmtMap})
    // console.log('PaymentSumCard - this.paymentMap:', this.paymentMap)
    //
    // console.log('PaymentSumCard - transList:', this.transList)
    // await this.$store.dispatch('rspFeeNameManage/findRspFeeNameDDList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proj/FundStatSumCard.vue